import React, { Component } from 'react'
import PropTypes from 'prop-types'
import t from 'tcomb-form'
import { emailValidation } from '../../../Lib/FormUtils'
import I18n from '../../../i18n/i18n'
import FullScreenLoader from '../../UI/Loaders/FullScreenLoader'
import FormCard from '../../UI/ContentCards/FormCard'
import FacebookButton from '../../UI/Buttons/FacebookButton'
import SimpleTextButton from '../../UI/Buttons/SimpleTextButton'
import AppleLoginButton from '../../UI/Buttons/AppleLoginButton'
import AppText from '../../UI/Texts/AppText'
import Stores from '../../UI/Stores/Stores'
import { Images, Metrics } from '../../../Themes'
import styles from '../../Styles/Screens/Auth'

export default class Signup extends Component {

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onFacebookPress: PropTypes.func.isRequired,
    goToLogin: PropTypes.func.isRequired,
    goToTerms: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    activeLang: PropTypes.string.isRequired
  }

  static defaultProps = {
    onSubmit: null,
    onFacebookPress: null,
    goToLogin: null,
    goToTerms: null,
    fetching: null,
    activeLang: null
  }

  render = () => {
    return (
      <div style={styles.container}>
        <img src={Images.logo} alt={''} style={styles.logo} />
        <FormCard
          onSubmit={this.props.onSubmit}
          deleteButton={false}
          submitText={I18n.t('screens.auth.signup')}
          submitIcon={null}
          submitOnEnter={true}
          fields={{
            displayName: t.String,
            email: t.refinement(t.String, emailValidation),
            password: t.String
          }}
          fieldsOptions={{
            displayName: {
              label: I18n.t('shared.displayName'),
              autoCapitalize: 'none',
              autoCorrect: false,
              customTemplate: true
            },
            email: {
              label: I18n.t('shared.email'),
              autoCapitalize: 'none',
              autoCorrect: false,
              customTemplate: true
            },
            password: {
              label: I18n.t('shared.password'),
              password: true,
              secureTextEntry: true,
              customTemplate: true,
              type: 'password'
            }
          }}
          renderExtraContentAfterButtons={() => (
            <div>
              {/*<FacebookButton*/}
              {/*  buttonText={I18n.t('screens.auth.facebookLogin')}*/}
              {/*  onPress={this.props.onFacebookPress}*/}
              {/*  disabled={false}*/}
              {/*  customButtonStyle={{ marginTop: Metrics.baseMargin }}*/}
              {/*/>*/}
              <AppleLoginButton
                buttonText={I18n.t('screens.auth.appleLogin')}
              />
              <SimpleTextButton
                buttonText={I18n.t('screens.auth.linkLoginSignup')}
                onPress={this.props.goToLogin}
                disabled={false}
                customButtonStyle={styles.navigationLinksContainerFirst}
                customTextStyle={styles.navigationLinksText}
              />
            </div>
          )}
          renderExtraContentBeforeButtons={() => (
            <div>
              <AppText
                text={I18n.t('screens.auth.textTerms')}
                customStyle={Object.assign({}, styles.navigationLinksText, styles.termsText)}
              />
              <SimpleTextButton
                buttonText={I18n.t('screens.auth.linkTerms')}
                onPress={this.props.goToTerms}
                disabled={false}
                customButtonStyle={styles.termsLinksContainer}
                customTextStyle={styles.termsLinks}
              />
            </div>
          )}
        />
        <Stores activeLang={this.props.activeLang} />
        <FullScreenLoader visible={this.props.fetching}/>
      </div>
    )
  }

}